import React from 'react';
import map from 'lodash/map';

export default field => {
    let border = '#d7dde5';
    let background;

    return (
        <div className={field.className}>
            <label className={field.labelClass}>{field.label}</label>
            {map(field.options, (value, key) => {
                if (key === field.input.value)
                    background = field.primaryColor
                        ? field.primaryColor
                        : '#00aae6';

                return (
                    <span key={key} className={field.labelClass}>
                        <input
                            {...field.input}
                            id={key}
                            value={key}
                            name={field.input.name}
                            type="radio"
                            checked={key === field.input.value}
                            onChange={field.input.onChange}
                            className={field.inputClassName}
                            style={{
                                border:
                                    key === field.input.value
                                        ? '1px solid ' +
                                          (field.primaryColor
                                              ? field.primaryColor
                                              : '#00aae6')
                                        : '1px solid ' + border,
                            }}
                        />
                        <span
                            className={
                                key === field.input.value
                                    ? 'checked'
                                    : 'unchecked'
                            }
                            style={{
                                background: background,
                            }}
                        />
                        <label htmlFor={key} className={field.labelClass}>
                            {value}
                        </label>
                    </span>
                );
            })}
            {field.meta.touched && field.meta.error && !field.meta.active ? (
                <p className="validation-error">{field.meta.error}</p>
            ) : (
                ''
            )}
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/ui/components/Inputs/RadioInput.js